<template>
  <div class="inspiration-photo__wrapper">
    <div class="inspiration-photo">
      <div v-for="link in props.links" class="inspiration-photo__link" :class="{ 'inspiration-photo__link--reversed': link.linkX > 60 }" :style="`left: ${link.linkX}%; top: ${link.linkY}%`">

        <div class="absolute left-0 top-0 z-[3] h-[1em] text-sm tablet:text-base cursor-crosshair desktop:text-xl">
          <div class="inspiration-photo__point icon-loader" :style="`transform: rotate(${Math.floor(Math.random() * 180)}deg)`"></div>
        </div>

        <AtomsTextLink :href="link.page.url" target="_blank" class="inspiration-photo__link__content" data-pageelementname="photo_gallery_inspiration_ware_link" :data-pageelementspecification="props.name">
          <div class="inspiration-photo__link__name">
            {{ link.page.entity?.name ?? link.page.title }}
          </div>
          <div v-if="link.page.entity && link.page.entity.price.minPrice.price > 0" class="inspiration-photo__link__price">
            <div class="inspiration-photo__link__price__bg">
              {{ (link.page.entity.price.minPrice.afterCustomerSale !== link.page.entity.price.maxPrice.afterCustomerSale ? $t('od') + ' ' : '') + link.page.entity.price.minPrice.afterCustomerSaleFormatted }}
            </div>
          </div>
        </AtomsTextLink>

      </div>

      <AtomsImagesImage :src="`${useShopZone().value.staticResourcesRoot}/shopFiles/inspiration/${props.id}.${props.fileType}`" :alt="props.name" @click="openDetail()" :class="[{ 'cursor-pointer': !props.isDetail }, props.imageClass]" />
    </div>
    <strong v-if="props.name">{{ props.name }}</strong>
  </div>
</template>
<script setup>

const props = defineProps({
  id: Number,
  fileType: String,
  name: String,
  links: Array,
  isDetail: Boolean,
  imageClass: String
});

const appConfig = useAppConfig();
const dialog = useDialog();

const openDetail = () => {
  if (props.isDetail) return;

  dialog.open('inspirationDetail', { id: props.id, fileType: props.fileType, name: props.name, links: props.links });
};

</script>
<style lang="postcss">
.inspiration-photo {
  @apply inline-block relative;

  &__wrapper {
    @apply mb-4 tracking-normal;
  }

  &__point {
    @apply absolute -left-[0.5em] top-[0.5em] w-[1em] h-[1em] -my-[1em] rounded-full;
    font-size: 1.9em;

    &::before {
      font-size: 1em;
    }

    &::after {
      @apply absolute left-0 top-0 right-0 bottom-0;
      content: '';
      background: radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
      border-radius: 50%;
      clip-path: polygon(0% 0%, 0% 50%, 50% 50%, 75% 0%);
    }
  }

  &__link {

    @apply absolute w-[50%] tablet:w-[35%] max-w-[250px] tablet:min-w-[200px] tablet:max-w-none hover:z-[4];

    &__content {
      @apply absolute block left-0 top-0 opacity-0 transition-all delay-150 duration-300 ease-in-out pointer-events-none tablet:left-2 tablet:top-2 desktop:left-2 desktop:top-2 hover:no-underline;
    }

    &__name {
      @apply relative z-[1] py-[0.5em] px-[1.5em] leading-5 font-bold bg-neutral-50 tablet:px-[2em] desktop:px-[3em];
      clip-path: polygon(0 1.5em, 1.5em 0, 100% 0, 100% calc(100% - 1.5em), calc(100% - 1.5em) 100%, 0 100%);
    }

    &__price {

      @apply absolute inline-block right-[3.3em] top-4 text-sm font-bold transition-all delay-200 duration-300 ease-in-out;

      &__bg {
        @apply -mt-[1px] pl-4 pr-6 py-1 bg-neutral-200;
        clip-path: polygon(0 0, 100% 0, 100% calc(100% - 1em), calc(100% - 1em) 100%, 0 100%);
      }

      &::after {
        @apply content-['»'] leading-[1.25rem] absolute left-0 top-0 z-[-1] -mt-[1px] block w-[3.25rem] h-[1.5rem] text-2xl font-bold text-center bg-primary-500 text-neutral-50 transition-all delay-300 duration-300 ease-in-out;
        clip-path: polygon(0 0, 100% 0, calc(100% - 0.5em) 0, 100% 50%, calc(100% - 0.5em) 100%, 0 100%);
      }
    }

    &:hover {
      .inspiration-photo__link__content {
        @apply opacity-100 z-[2] delay-[600] pointer-events-auto;
      }

      .inspiration-photo__link__price {
        @apply top-full;

        &::after {
          @apply left-[calc(100%-0.75rem)];
        }
      }
    }

    &--reversed {
      .inspiration-photo__link__content {
        @apply w-full -left-full;
      }

      .inspiration-photo__link__name {
        clip-path: polygon(0 0, calc(100% - 1.5em) 0, 100% 1.5em, 100% 100%, 1.5em 100%, 0 calc(100% - 1.5em));
      }
    }
  }
}
</style>